import Icon from "./Icon";
import {useState} from "react";

function Checks({name, label, icon, onChange, value, options}) {
    label = label ? label : "انتخاب کنید";
    name = name ? name : "checks";
    options = options ? options : [];
    value = value ? value : [];

    const [mValue, setMValue] = useState({value: value});

    const active = (o) => {
        let isActive = false;
        mValue.value.map(v => {
            if (v === o) {
                isActive = true;
            }
        })
        return isActive;
    }

    const onCheck = (o) => {
        let index = -1;
        mValue.value.map((v, i) => {
            if (o === v) {
                index = i;
            }
        });

        let values = mValue.value;

        if (index === -1) {
            values.push(o)
        } else {
            values.splice(index, 1);
        }

        setMValue({value: values});

        if (onChange) {
            onChange(name, values);
        }
    }
    return (
        <div className="mui-checks">
            <div className="label" id={name}>
                {icon ? <Icon i={icon}/> : null}
                <span className="title">{label}:</span>
            </div>

            <div className="options">
                {options.map((o, i) =>
                    <div className={active(o) ? "check active" : "check"} key={name + "-" + "check-" + i}
                         onClick={() => {
                             onCheck(o);
                         }}>
                        <div className="row">
                            <div className="col-auto">
                                <Icon i="check" light={!active(o)} solid={active(o)}/>
                            </div>
                            <div className="col">
                                <div className="title">{o}</div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}

export default Checks;